import { useEffect } from "react";
import { create } from "zustand";

const STORAGE_KEY = "clipra-affiliate-theme";

const readInitial = () => {
  if (typeof window === "undefined") return "dark";
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored === "light" || stored === "dark") return stored;
  } catch {
    // localStorage may be disabled — fall through
  }
  if (window.matchMedia?.("(prefers-color-scheme: light)").matches) return "light";
  return "dark";
};

const applyToHtml = (theme) => {
  if (typeof document === "undefined") return;
  const root = document.documentElement;
  if (theme === "dark") root.classList.add("dark");
  else root.classList.remove("dark");
  root.style.colorScheme = theme;
};

export const useAffTheme = create((set, get) => ({
  theme: "dark",
  initFromStorage: () => {
    const t = readInitial();
    applyToHtml(t);
    set({ theme: t });
  },
  toggle: () => {
    const next = get().theme === "dark" ? "light" : "dark";
    try {
      window.localStorage.setItem(STORAGE_KEY, next);
    } catch {
      // ignore
    }
    applyToHtml(next);
    set({ theme: next });
  },
}));

export const useAffThemeInit = () => {
  const initFromStorage = useAffTheme((s) => s.initFromStorage);
  useEffect(() => {
    initFromStorage();
  }, [initFromStorage]);
};
